export const INITIALIZE_NOTIFICATION_CHANNEL_DATA = 'INITIALIZE_NOTIFICATION_CHANNEL_DATA';

export const ADD_NOTIFICATION_CHANNEL = 'ADD_NOTIFICATION_CHANNEL';

export const UPDATE_NOTIFICATION_CHANNEL = 'UPDATE_NOTIFICATION_CHANNEL';
